module.exports = __webpack_public_path__ + "static/img/v100_bg.b826640.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/v100_bg.jpeg
// module id = BDO5
// module chunks = 0